"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHeaders = void 0;
var tslib_1 = require("tslib");
var createHeaders = function (headerSettings) {
    return tslib_1.__assign({ 'Content-Type': 'text/plain' }, (typeof headerSettings === 'function'
        ? headerSettings()
        : headerSettings));
};
exports.createHeaders = createHeaders;
//# sourceMappingURL=shared-dispatcher.js.map